import * as React from 'react';
import Field from '../Field/Field';
import { default as Button } from '../../Button';
import { Form } from 'react-final-form';
import { useTheme } from '../../theme';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../../context';
import { removeTrailingSlash } from '../../utils';
import { useRetrieveBookingValidation } from '../../RetrieveBooking/hooks';
const Booking = () => {
    const engineURL = useConfig().SearchForm.engineURL;
    const { t } = useTranslation('Forms');
    const theme = useTheme('Forms').Booking;
    const { ticketNumberValidation, validateByOrderNumber, requiredValidation, requiredValidationWrapper } = useRetrieveBookingValidation();
    const onOrderNumberValidation = (value) => {
        const ticketNumberError = ticketNumberValidation(value);
        const orderNumberError = validateByOrderNumber(value);
        if (!ticketNumberError || !orderNumberError) {
            return undefined;
        }
        return ticketNumberError || orderNumberError;
    };
    const onSubmit = (values) => {
        window.location.href = `${removeTrailingSlash(engineURL)}/#/find/${values['orderNumber']}/${values['lastName']}/Submit`;
    };
    return (React.createElement(Form, { onSubmit: onSubmit, initialValues: {
            orderNumber: '',
            lastName: ''
        } }, ({ handleSubmit }) => (React.createElement("div", { className: theme.container },
        React.createElement("form", { onSubmit: handleSubmit, className: theme.inner },
            React.createElement(Field, { name: "orderNumber", label: t('Order number'), validation: requiredValidationWrapper(onOrderNumberValidation) }),
            React.createElement(Field, { name: "lastName", label: t('Last name'), validation: requiredValidation }),
            React.createElement(Button, { type: "submit", variant: "flat", size: "large", className: theme.submit }, t('Find')))))));
};
export default Booking;
